export const formatToDateAndTime = (
  dateTimeString: string | number | Date
): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };

  const formattedDate = new Date(dateTimeString).toLocaleString(
    "en-IN",
    options
  );

  return formattedDate;
};

export const formatToDate = (
  dateTimeString: string | number | Date
): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  const formattedDate = new Date(dateTimeString).toLocaleString(
    "en-IN",
    options
  );

  return formattedDate;
};


export const convertTimeTo12HourReadbleFormat = (
  timeString: string
): string | undefined => {
  // Split the time string into hours, minutes, and seconds

  if (!timeString) return;

  const [hours, minutes] = timeString.split(":").map(Number);

  // Determine AM/PM and convert hours to 12-hour format
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12 AM

  // Format minutes with leading zero if less than 10
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  // Return the formatted time string
  return `${formattedHours}:${formattedMinutes} ${ampm}`;
};

export const convertTimeTo12HourFormat = (time: string) => {
  const [hour, minute] = time.split(":");
  const hourNum = parseInt(hour);
  const meridiem = hourNum >= 12 ? "PM" : "AM";
  const formattedHour = hourNum % 12 === 0 ? 12 : hourNum % 12;
  return { hour: formattedHour, minute, meridiem };
};

export function convertTimeTo24HourFormat({
  hour,
  minute,
  meridiem,
}: {
  hour: string | number;
  minute: string;
  meridiem: string;
}): string {
  let hourNum = parseInt(String(hour), 10);
  if (meridiem === "PM" && hourNum < 12) {
    hourNum += 12;
  } else if (meridiem === "AM" && hourNum === 12) {
    hourNum = 0;
  }
  return `${hourNum < 10 ? "0" + hourNum : hourNum}:${minute}`;
}